module.exports = __webpack_public_path__ + "static/media/bluecoin.acb1af79.svg";